import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import '@fontsource/inter'; // Defaults to 400 weight

// import { I18nextProvider } from 'react-i18next';
// import i18n from './i18n'; 
// import { BrowserRouter } from 'react-router-dom';



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    
    <App />
    





);

